import { createSlice, configureStore, createStore, applyMiddleware, compose } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'
import { thunk } from 'redux-thunk'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(rootReducer, 
    composeEnhancers(applyMiddleware(thunk)))
export default store